import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Modal from 'eventtia-ui-components/lib/Modal';
import QrCode from 'qrcode.react';
// import ResponsiveButton from '../ResponsiveButton';
// import Tooltip from '@material-ui/core/Tooltip';
import Button from 'eventtia-ui-components/lib/Button';
import QrCodeIcon from '../../assets/QrCodeIcon';
import { buildQrContent } from '../../helpers/attendeeLeads';

const useStyles = makeStyles((theme) => ({
  dialog: {
    width: 430,
    maxWidth: '100%',
    height: '100%',
    textAlign: 'center',
    position: 'relative',
    backgroundColor: theme.palette.lightGrey.light,
    padding: theme.spacing(8, 10),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      left: theme.spacing(2),
      top: 30,
      justifyContent: 'flex-start',
    },
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    color: 'black',
  },
  message: {
    color: theme.palette.darkGrey.main,
    margin: theme.spacing(1, 0),
  },
  qrContainer: {
    display: 'inline-block',
    borderRadius: 8,
    padding: theme.spacing(4),
    margin: theme.spacing(2, 0),
    background: 'white',
  },
  qrButton: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    width: '100%',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 255,
    },
  },
  qrMobileButton: {
    marginRight: -theme.spacing(1.5),
  },
  modal: {
    [theme.breakpoints.down('sm')]: {
      zIndex: '1500 !important',
    },
  },
}));

const ResponsiveButton = ({ icon, onClick, label, disabled }) => {
  // const theme = useTheme();
  // const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();

  // if (mobile) return (
  //   <Tooltip title={label} placement="top" className={classes.qrMobileButton}>
  //     <IconButton
  //       onClick={onClick}
  //       aria-label={label}
  //       color="primary"
  //       disabled={disabled}
  //     >
  //       {icon}
  //     </IconButton>
  //   </Tooltip>
  // );
  return (
    <Button
      onClick={onClick}
      variant="primary"
      icon={icon}
      disabled={disabled}
      className={classes.qrButton}
    >
      {label}
    </Button>
  );
};

const MyQrButton = ({ attendeeInfo }) => {
  const classes = useStyles();
  const { t } = useTranslation('global');
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [open, setOpen] = useState(false);
  const openModal = () => {
    setOpen(true);
  };
  const closeModal = () => {
    setOpen(false);
  };

  const {
    uuid, firstName, lastName, email, company, jobTitle, telephone,
  } = attendeeInfo;
  const qrContent = buildQrContent(uuid, firstName, lastName, email, company, jobTitle, telephone);

  return (
    <>
      <ResponsiveButton
        onClick={openModal}
        icon={<QrCodeIcon />}
        label={t('actions.showQr')}
      />
      <Modal
        open={open}
        handleClose={closeModal}
        fullScreen={fullScreen}
        maxWidth="md"
        className={classes.modal}
      >
        <Paper
          className={classes.dialog}
        >
          <IconButton
            className={classes.closeButton}
            aria-label={t('actions.close')}
            onClick={closeModal}
            edge="end"
            color="primary"
            size="small"
          >
            <CloseIcon />
          </IconButton>
          <Typography className={classes.title}>
            {`${firstName} ${lastName}`}
          </Typography>
          <Typography className={classes.message}>
            {t('attendeeLeads:qr.personalQr')}
          </Typography>
          <div className={classes.qrContainer}>
            <QrCode value={qrContent} />
          </div>
          <Typography className={classes.message}>
            Show this QR code to acces all the sessions
          </Typography>
        </Paper>
      </Modal>
    </>
  );
};

MyQrButton.propTypes = {
  attendeeInfo: PropTypes.shape({
    uuid: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    company: PropTypes.string,
    jobTitle: PropTypes.string,
    telephone: PropTypes.string,
  }).isRequired,
  // showLeadsOptions: PropTypes.bool.isRequired,
};

ResponsiveButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.element.isRequired,
  disabled: PropTypes.bool,
};

ResponsiveButton.defaultProps = {
  disabled: false,
};

export default MyQrButton;
